import React from 'react';
import ReactDOM from 'react-dom';
import Joi from 'joi-browser';
import Loading from './components/common/loader';
import Error from './components/common/error';
import * as serviceWorker from './serviceWorker';
import App from './App';
import { apiUrl } from './config.json';
import { login, getJwt, getLogin, setLogin } from './services/authService';

function submit(data) {
  const target = apiUrl;

  ReactDOM.render(
    <Loading type="Rings" title="Attendi mentre troviamo gli appuntamenti" />,
    document.getElementById('appointmentPicker')
  );
  const myRequest = new XMLHttpRequest();
  myRequest.open('POST', target);

  const json = JSON.stringify(data);
  myRequest.send(json);

  myRequest.onreadystatechange = () => {
    if (myRequest.readyState === 4) {
      // console.log(myRequest.responseText );
      const d = JSON.parse(myRequest.responseText);

      if (d.status === 'success') {
        // sessionStorage.setItem('token', d.data.token);
        setLogin({
          lead_id: d.data.lead_id,
          converted_id: d.data.converted_id,
          data: data,
        });
        // sessionSet('converted_id', d.data.converted_id, sessionTimeoutInMinuets);
        //sessionSet('fonti', d.data.fonti, sessionTimeoutInMinuets);
        // sessionStorage.setItem('lead_id', d.data.lead_id);
        // sessionStorage.setItem('converted_id', d.data.converted_id);
        // sessionStorage.setItem('fonti', d.data.fonti);

        ReactDOM.render(<App />, document.getElementById('appointmentPicker'));
      } else {
        ReactDOM.render(
          <Error
            title="Abbiamo riscontrato un problema"
            subtitle="Riprova più tardi cliccando qui"
            link="/"
          />,
          document.getElementById('appointmentPicker')
        );
      }
      serviceWorker.unregister();
    } else {
      ReactDOM.render(
        <Error
          title="Abbiamo riscontrato un problema"
          subtitle="Riprova più tardi cliccando qui"
          link="/"
        />,
        document.getElementById('appointmentPicker')
      );
    }
  };
}
function getAppoinments(ev) {
  ev.preventDefault();
  ev.stopImmediatePropagation();
  const data = {};
  data.first_name = document.getElementById('first_name').value;
  data.last_name = document.getElementById('last_name').value;
  data.email = document.getElementById('email').value;
  data.phone = document.getElementById('phone').value;
  data.city = document.getElementById('city').value;
  data.tipologia_Appartamento__c = document.getElementById(
    'tipologia_Appartamento__c'
  ).value;
  data.Fonti_Pubblicitarie__c = document.getElementById(
    'Fonti_Pubblicitarie__c'
  ).value;
  // data.Description = document.getElementById('Description').value;

  document.querySelector('#check1:checked')
    ? (data.check1 = 1)
    : (data.check1 = 0);
  document.querySelector('#check2:checked')
    ? (data.check2 = 1)
    : (data.check2 = 0);

  const schema = Joi.object().keys({
    first_name: Joi.string().alphanum().min(3).max(30).required(),
    last_name: Joi.string().alphanum().min(3).max(30).required(),
    city: Joi.string().min(2).max(130).required(),
    phone: Joi.number().required(),
    email: Joi.string().email().required(),
    tipologia_Appartamento__c: Joi.string().trim().allow('').optional(),
    Fonti_Pubblicitarie__c: Joi.string().trim().allow('').optional(),
    Description: Joi.string().trim().allow('').optional(),
    check1: Joi.number().required(),
    check2: Joi.number().required(),
  });

  // eslint-disable-next-line no-return-assign
  Object.keys(data).map(
    (key) => (document.getElementById(key).style.borderColor = 'none')
  );
  Joi.validate(data, schema, (err) => {
    if (!err) {
      data.action = 'get_lead_id';
      data.token = getJwt();
      submit(data);
    } else {
      // eslint-disable-next-line no-return-assign
      err.details.map(
        (item) => (document.getElementById(item.path).style.borderColor = 'red')
      );
    }
  });
}
const form = document.getElementById('email-form');
form.onsubmit = getAppoinments;

if (!getJwt()) login();
const loginData = getLogin();
// const LeadId = getLogin('login').lead_id;
// const ConvertedId = getLogin('login').converted_id;
if (getJwt() && loginData && (loginData.lead_id || loginData.converted_id)) {
  ReactDOM.render(<App />, document.getElementById('appointmentPicker'));
}
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
